import * as z from "zod/v4";

export const subscribeToMetaLeadAdsWebhooks = {
  name: "subscribeToMetaLeadAdsWebhooks" as const,
  input: z.object({ pageId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
